import { render, staticRenderFns } from "./forgot-password-request.vue?vue&type=template&id=db1f5a2c&scoped=true"
import script from "./forgot-password-request.vue?vue&type=script&lang=js"
export * from "./forgot-password-request.vue?vue&type=script&lang=js"
import style0 from "./forgot-password-request.vue?vue&type=style&index=0&id=db1f5a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1f5a2c",
  null
  
)

export default component.exports